import {ApiStatusCodeVo} from '../../common/shared/api/nicolas/vo/enums/ApiStatusCodeVo.enum';
import {UpdateNicknameResultVo} from '../../common/shared/api/nicolas/vo/UpdateNicknameVo.interface';
import {UpdateProfileImageResultVo} from '../../common/shared/api/nicolas/vo/UpdateProfileImageResultVo.interface';
import {ResultStatus, UpdateNicknamePayload} from '../generated/types';

export function createNicknameInfo({
  nickname,
  should_update_profile,
}: UpdateNicknameResultVo): UpdateNicknamePayload {
  return {
    nickname,
    shouldUpdateProfile: should_update_profile === 'Y',
    status: ResultStatus.Success,
  };
}

export function createUpdateProfileImageInfo({
  profile_image,
  result_code,
  message,
}: UpdateProfileImageResultVo): UpdateProfileImageResult {
  return {
    profileImage: profile_image,
    resultCode: result_code,
    message,
  };
}

export interface UpdateProfileImageResult {
  profileImage: string;
  resultCode: ApiStatusCodeVo;
  message?: string;
}
